module.exports = __webpack_public_path__ + "img/schema_infinity_with_words_english.fc6c0536.svg";